import React from 'react';
import { Reveal } from './Reveal';
import { Check } from 'lucide-react';
export const DailyReportSection = () => {
  return <section className="py-12 md:py-16 px-[5vw] bg-bg" data-id="element-63">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-64">
        {/* Left: Text */}
        <Reveal data-id="element-65">
          <div data-id="element-66">
            <span className="text-xs font-bold tracking-widest text-ink-soft uppercase mb-4 block" data-id="element-67">
              FIM DE MÊS
            </span>
            <h2 className="font-serif font-bold text-[26px] md:text-[clamp(34px,4vw,48px)] tracking-[-0.02em] text-ink mb-6 leading-tight" data-id="element-68">
              Você abre o app e sabe quanto sobrou. Pronto.
            </h2>
            <p className="text-[15px] md:text-[17px] leading-[1.6] text-ink-soft mb-8" data-id="element-69">
              No último dia do mês, você não precisa abrir 4 cadernos, nem somar
              nota fiscal, nem chutar.
            </p>

            <div className="space-y-6 mb-4" data-id="element-70">
              <div className="flex gap-4" data-id="element-71">
                <div className="w-6 h-6 rounded-full bg-rose flex items-center justify-center flex-shrink-0 mt-1" data-id="element-72">
                  <Check size={14} className="text-white" data-id="element-73" />
                </div>
                <div data-id="element-74">
                  <h4 className="font-medium text-ink mb-1" data-id="element-75">
                    O leite condensado subiu? Seus preços sobem junto, sozinhos.
                  </h4>
                  <p className="text-sm text-ink-soft" data-id="element-76">
                    Você atualiza o preço de UM material. Todos os produtos que
                    usam ele se reajustam na hora. Sem refazer planilha, sem
                    refazer cálculo e sem deixar lucro na mesa.
                  </p>
                </div>
              </div>
              <div className="flex gap-4" data-id="element-77">
                <div className="w-6 h-6 rounded-full bg-rose flex items-center justify-center flex-shrink-0 mt-1" data-id="element-78">
                  <Check size={14} className="text-white" data-id="element-79" />
                </div>
                <div data-id="element-80">
                  <h4 className="font-medium text-ink mb-1" data-id="element-81">
                    Histórico de cada preço, igual extrato de banco.
                  </h4>
                  <p className="text-sm text-ink-soft" data-id="element-82">
                    Toda mudança fica salva. Você consegue olhar pra trás e ver:
                    "meu brigadeiro custava R$ 1,80 em janeiro, hoje custa R$
                    2,40". Você decide se aumenta o preço com base em fato,
                    chega de achômetro.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Reveal>

        {/* Right: Data Cards */}
        <Reveal delay={0.2} data-id="element-83">
          <div className="space-y-6" data-id="element-84">
            {/* Card 1: Monthly Summary */}
            <div className="bg-white rounded-[20px] p-6 border border-line shadow-sm hover:-translate-y-1 transition-transform" data-id="element-85">
              <div className="flex justify-between items-center mb-6" data-id="element-86">
                <div data-id="element-87">
                  <h3 className="font-medium text-ink" data-id="element-88">Resumo Abril 2026</h3>
                </div>
                <div className="bg-rose-soft text-rose text-xs font-bold px-2 py-1 rounded flex items-center gap-1" data-id="element-89">
                  <Check size={12} data-id="element-90" /> Atualizado
                </div>
              </div>

              <div className="grid grid-cols-2 gap-y-6 gap-x-4" data-id="element-91">
                <div data-id="element-92">
                  <p className="text-xs text-ink-soft mb-1" data-id="element-93">Faturamento</p>
                  <p className="font-serif font-bold text-xl text-gold" data-id="element-94">
                    R$ 1.840
                  </p>
                </div>
                <div data-id="element-95">
                  <p className="text-xs text-ink-soft mb-1" data-id="element-96">Lucro real</p>
                  <p className="font-serif font-bold text-xl text-[#059669]" data-id="element-97">
                    R$ 920
                  </p>
                </div>
                <div data-id="element-98">
                  <p className="text-xs text-ink-soft mb-1" data-id="element-99">Pedidos</p>
                  <p className="font-serif font-bold text-xl text-rose" data-id="element-100">12</p>
                </div>
                <div data-id="element-101">
                  <p className="text-xs text-ink-soft mb-1" data-id="element-102">Margem média</p>
                  <p className="font-serif font-bold text-xl text-ink" data-id="element-103">58%</p>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
};